var main = require('integrations/main');

main.baseFiles.cart = require('./cart');
main.baseFiles.menu = require('./components/menu');
main.baseFiles.miniCart = require('./components/miniCart');
main.baseFiles.base = require('./product/base');
main.baseFiles.enrollments = require('./product/enrollments');
main.baseFiles.helpers = require('./helpers/helpers');

module.exports = main;
